/**
 * Date utility functions for consistent date formatting across the application
 */

/**
 * Format datetime for server API
 * Accepts input format "YYYY-MM-DDTHH:MM" or "YYYY-MM-DD HH:MM[:SS]"
 * Returns "YYYY-MM-DD HH:MM:SS"
 * @param {string} value - The date value to format
 * @returns {string|undefined} Formatted date string or undefined if empty
 */
export const formatDateTimeForServer = (value) => {
  if (!value) return undefined;
  const trimmed = `${value}`.trim();
  if (!trimmed) return undefined;
  const withSpace = trimmed.includes('T') ? trimmed.replace('T', ' ') : trimmed;
  return withSpace.length === 16 ? `${withSpace}:00` : withSpace;
};

/**
 * Convert server datetime format to datetime-local input format
 * Accepts server format "YYYY-MM-DD HH:MM[:SS]" or input format
 * Returns "YYYY-MM-DDTHH:MM"
 * @param {string} value - The date value to convert
 * @returns {string} Formatted date string for datetime-local input
 */
export const toDatetimeLocal = (value) => {
  if (!value) return '';
  const raw = `${value}`.trim();
  if (!raw) return '';
  const withT = raw.replace(' ', 'T');
  return withT.slice(0, 16);
};

/**
 * Format a Date object to datetime-local input format
 * Returns "YYYY-MM-DDTHH:MM"
 * @param {Date} date - The date object to format
 * @returns {string} Formatted date string for datetime-local input
 */
export const formatDateToInput = (date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const HH = String(date.getHours()).padStart(2, '0');
  const MM = String(date.getMinutes()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}T${HH}:${MM}`;
};
